import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faChevronDown, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import c2cLogo from '../assets/images/c2c-logo-name.png';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProductMenuOpen, setIsProductMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [

    { name: 'How it Works', href: '#how-it-works' },
    { name: 'Industries', href: '#industries' },
    { name: 'Pricing', href: '#pricing' },
    { name: 'Features', href: '/features' },
    { name: 'User Guide', href: '/user-guide' },
    // { name: 'Contact', href: '#contact' }
  ];

  const productLinks = [
    { name: 'C2C Business', href: '/?product=c2c#products' },
    { name: 'C2C Softphone', href: '/softphone' },
    { name: 'C2C Appliance', href: '/?product=appliance#products' },
    { name: 'C2C AI Agent', href: '/?product=ai#products' }
  ];

  const handleNavClick = (e, href) => {
    if (!href.startsWith('#')) {
      setIsMobileMenuOpen(false);
      return;
    }

    e.preventDefault();

    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => scrollToSection(href), 0);
      return;
    }

    scrollToSection(href);
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleLogoClick = () => {
    setIsMobileMenuOpen(false);
    window.setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  };

  const handleProductClick = () => {
    setIsProductMenuOpen(false);
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <Link to="/" className="nav-logo" onClick={handleLogoClick}>
            <img src={c2cLogo} alt="Context to Call" className="logo-image" />
            <span className="logo-text">Context to Call</span>
          </Link>

          <ul className="nav-links desktop-only">
            <li
              className={`nav-dropdown ${isProductMenuOpen ? 'open' : ''}`}
              onMouseEnter={() => setIsProductMenuOpen(true)}
              onMouseLeave={() => setIsProductMenuOpen(false)}
            >
              <button
                type="button"
                className="nav-dropdown-trigger"
                onFocus={() => setIsProductMenuOpen(true)}
                onClick={() => setIsProductMenuOpen((isOpen) => !isOpen)}
                aria-expanded={isProductMenuOpen}
              >
                Products <FontAwesomeIcon icon={faChevronDown} />
              </button>
              <div className="nav-dropdown-menu">
                {productLinks.map((product) => (
                  <Link key={product.name} to={product.href} onClick={handleProductClick}>
                    {product.name}
                  </Link>
                ))}
              </div>
            </li>
            {navLinks.map((link) => (
              <li key={link.name}>
                {link.href.startsWith('#') ? (
                  <a href={link.href} onClick={(e) => handleNavClick(e, link.href)}>
                    {link.name}
                  </a>
                ) : (
                  <Link to={link.href} onClick={() => setIsMobileMenuOpen(false)}>
                    {link.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>

          <div className="nav-actions desktop-only">
            <Button variant="ghost" asChild>
              <a href="https://app.contexttocall.com/account/sign-in" target="_blank" rel="noopener noreferrer">
                Sign In
              </a>
            </Button>
            <Button asChild className="nav-demo-btn">
              <Link to="/demo" onClick={() => setIsMobileMenuOpen(false)}>
                Book a Demo
              </Link>
            </Button>
          </div>

          <button 
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <FontAwesomeIcon icon={faXmark} /> : <FontAwesomeIcon icon={faBars} />}
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <div className="mobile-products">
            <div className="mobile-products-label">Products</div>
            {productLinks.map((product) => (
              <Link key={product.name} to={product.href} onClick={() => setIsMobileMenuOpen(false)}>
                {product.name}
              </Link>
            ))}
          </div>
          {navLinks.map((link) => (
            link.href.startsWith('#') ? (
              <a key={link.name} href={link.href} onClick={(e) => handleNavClick(e, link.href)}>
                {link.name}
              </a>
            ) : (
              <Link key={link.name} to={link.href} onClick={() => setIsMobileMenuOpen(false)}>
                {link.name}
              </Link>
            )
          ))}
          <div className="mobile-menu-actions">
            <Button variant="ghost" asChild className="w-full">
              <a href="https://app.contexttocall.com/account/sign-in" target="_blank" rel="noopener noreferrer">
                Sign In
              </a>
            </Button>
            <Button asChild className="nav-demo-btn w-full">
              <Link to="/demo" onClick={() => setIsMobileMenuOpen(false)}>
                Book a Demo
              </Link>
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default Navigation;
